import { motion } from "framer-motion";

export default function PageHeader({ eyebrow, title, description }) {
    return (
        <section className="relative pt-40 pb-20 md:pt-48 md:pb-28 overflow-hidden" data-testid="page-header">
            <div className="absolute inset-0 bg-grid bg-grid-fade opacity-30 pointer-events-none" />
            <div className="absolute -top-40 right-0 w-[500px] h-[500px] rounded-full bg-blue-600/10 blur-[120px] pointer-events-none" />

            <div className="relative max-w-7xl mx-auto px-6 md:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="max-w-4xl"
                >
                    {eyebrow && (
                        <div className="inline-flex items-center gap-2 text-xs font-mono tracking-[0.2em] uppercase text-cyan-400 mb-6">
                            <span className="w-8 h-px bg-cyan-400/60" /> {eyebrow}
                        </div>
                    )}
                    <h1 className="font-heading font-black text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tighter">
                        {title}
                    </h1>
                    {description && (
                        <p className="mt-8 text-lg md:text-xl text-slate-400 leading-relaxed max-w-2xl">
                            {description}
                        </p>
                    )}
                </motion.div>
            </div>
        </section>
    );
}
